"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CuadrupleLine_exports = {};
__export(CuadrupleLine_exports, {
  default: () => CuadrupleLine_default
});
module.exports = __toCommonJS(CuadrupleLine_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.75 16.5C17.1016 16.5 17.3945 16.6237 17.6289 16.8711C17.8763 17.1055 18 17.3984 18 17.75C18 18.1016 17.8763 18.401 17.6289 18.6484C17.3945 18.8828 17.1016 19 16.75 19H4.25C3.89844 19 3.59896 18.8828 3.35156 18.6484C3.11719 18.401 3 18.1016 3 17.75C3 17.3984 3.11719 17.1055 3.35156 16.8711C3.59896 16.6237 3.89844 16.5 4.25 16.5H16.75ZM16.75 11.5C17.1016 11.5 17.3945 11.6237 17.6289 11.8711C17.8763 12.1055 18 12.3984 18 12.75C18 13.1016 17.8763 13.401 17.6289 13.6484C17.3945 13.8828 17.1016 14 16.75 14H4.25C3.89844 14 3.59896 13.8828 3.35156 13.6484C3.11719 13.401 3 13.1016 3 12.75C3 12.3984 3.11719 12.1055 3.35156 11.8711C3.59896 11.6237 3.89844 11.5 4.25 11.5H16.75ZM16.75 6.5C17.1016 6.5 17.3945 6.6237 17.6289 6.87109C17.8763 7.10547 18 7.39844 18 7.75C18 8.10156 17.8763 8.40104 17.6289 8.64844C17.3945 8.88281 17.1016 9 16.75 9H4.25C3.89844 9 3.59896 8.88281 3.35156 8.64844C3.11719 8.40104 3 8.10156 3 7.75C3 7.39844 3.11719 7.10547 3.35156 6.87109C3.59896 6.6237 3.89844 6.5 4.25 6.5H16.75ZM16.75 1.5C17.1016 1.5 17.3945 1.6237 17.6289 1.87109C17.8763 2.10547 18 2.39844 18 2.75C18 3.10156 17.8763 3.40104 17.6289 3.64844C17.3945 3.88281 17.1016 4 16.75 4H4.25C3.89844 4 3.59896 3.88281 3.35156 3.64844C3.11719 3.40104 3 3.10156 3 2.75C3 2.39844 3.11719 2.10547 3.35156 1.87109C3.59896 1.6237 3.89844 1.5 4.25 1.5H16.75Z",
      fill: "currentColor"
    }
  )
);
const SvgCuadrupleLine = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CuadrupleLine_default = SvgCuadrupleLine;
